const submissionFileFields = [
  'SourceFiles',
  'Manuscript',
  'TitlePage',
  'CompleteDocumentForReview',
  'AnonymizedManuscript',
  'Supplementary',
  'AdditionalSupplementary',
  'CoverLetter',
  'Figures',
  'Tables',
  'FiguresAndTables',
  'GraphicalAbstractImage'
];

const submissionInformationFields = [
  'FocusIssue',
  'Title',
  'EnglishTitle',
  'Subtitle',
  'EnglishSubtitle',
  'Abstract',
  'EnglishAbstract',
  'Keywords',
  'EnglishKeywords',
  'ArticleSubtype',
  'ArticleLanguage',
  'Category',
  'CategoryOther',
  'StandardReportingGuidelines',
  'NumberOfFigures',
  'NumberOfColorFigures',
  'NumberOfTables',
  'NumberOfWords',
  'GeneralClassifications'
];

const authorInformationFields = [
  'Authors',
  'SubmittingAuthor',
  'CorrespondingAuthor',
  'ContactAuthor'
];

const submissionPreferenceFields = [
  'CommentForEditor',
  'CoAuthorApproval',
  'PublishingModel',
  'OpenAccessChoice',
  'OpenAccessChoiceWorldBankACountry',
  'OpenAccessChoiceWorldBankBCountry',
  'OpenAccessChoiceReviewerDiscountRate',
  'PreferenceImmediatePublication',
  'LicensesAndPermissions',
  'LicensesAndPermissionsReproducedContent',
  'LicensesAndPermissionsFiles',
  'TransparentPeerReview',
  'DoubleAnonymousPeerReview',
  'RecommendedReviewers',
  'OpposedReviewers',
  'NoveltyStatement',
  'DataAvailability',
  'DataAvailabilityOpenlyAvailableUrl',
  'DataAvailabilityEmbargoUrl',
  'DataAvailabilityEmbargoDate',
  'DataUnavailabilityReason',
  'DataAvailabilityStatement',
  'ClinicalTrials',
  'EthicsStatement',
  'Funding',
  'FundingGeneric',
  'AcceleratedPublication',
  'IPEMMembership',
  'SubjectArea',
  'PreviouslySubmitted',
  'ConflictOfInterestForAuthor',
  'AITools',
  'Preprint',
  'SharedDataset',
  'GeneratedDataset',
  'UtilizedDataset',
  'EthicalApproval',
  'EthicsApproval',
  'CopyrightLicensingForm'
];

const hasUpdatedField = (
  fieldNames: string[],
  checkFormFieldValueIsUpdated: (fieldName: string) => boolean
) => fieldNames.some(checkFormFieldValueIsUpdated);

export const getUnsubmittedReviewSections = (
  checkFormFieldValueIsUpdated: (fieldName: string) => boolean
) => {
  const hasSubmissionFileUpdates = hasUpdatedField(
    submissionFileFields,
    checkFormFieldValueIsUpdated
  );
  const hasSubmissionInformationUpdates = hasUpdatedField(
    submissionInformationFields,
    checkFormFieldValueIsUpdated
  );
  const hasAuthorInformationUpdates = hasUpdatedField(
    authorInformationFields,
    checkFormFieldValueIsUpdated
  );
  const hasSubmissionPreferenceUpdates = hasUpdatedField(
    submissionPreferenceFields,
    checkFormFieldValueIsUpdated
  );

  return {
    hasSubmissionFileUpdates,
    hasSubmissionInformationUpdates,
    hasAuthorInformationUpdates,
    hasSubmissionPreferenceUpdates,
    sections: [
      ...(hasSubmissionFileUpdates ? ['Submission Files'] : []),
      'Submission Unsubmitted by Editors',
      ...(hasSubmissionInformationUpdates ? ['Submission information'] : []),
      ...(hasAuthorInformationUpdates ? ['Author information'] : []),
      ...(hasSubmissionPreferenceUpdates ? ['Submission preferences'] : [])
    ]
  };
};
